import React, { ReactNode } from "react";

interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
  className?: string;
}

export default function Tooltip({
  content,
  children,
  className = "",
}: TooltipProps) {
  return (
    <div
      className={`group relative inline-flex items-center hover:z-[99999999] ${className}`}
    >
      {children}
      <div className="pointer-events-none absolute bottom-full left-1/2 mb-2 w-64 -translate-x-1/2 rounded-lg bg-gray-900 px-3 py-2 text-xs text-white opacity-0 shadow-sm transition-opacity group-hover:opacity-100 dark:bg-gray-700 z-[99999999]">
        {content}
        <div className="absolute left-1/2 top-full -translate-x-1/2 border-4 border-transparent border-t-gray-900 dark:border-t-gray-700"></div>
      </div>
    </div>
  );
}
